import { FormikHelpers } from "formik";
import { useGetAtm } from "./api/getAtm";
import { useEditAtm } from "./api/editAtm";
import EditAtmForm from "./EditAtmForm";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";


const EditAtm = ({handleCloseModal, atmId}: EditAtmProps)  => {
  const getAtmQuery = useGetAtm({atmId: atmId})
  const editAtmMutation = useEditAtm({data: {}, atmId});

  const initialValues : IEditAtmForm = {
    atmTerm: getAtmQuery.data?.atmTerm ? getAtmQuery.data?.atmTerm : "",
    atmAddress: getAtmQuery.data?.atmAddress ? getAtmQuery.data?.atmAddress : "",
    connMethod: getAtmQuery.data?.connMethod ? getAtmQuery.data?.connMethod : "",
    atmHost: getAtmQuery.data?.atmHost ? getAtmQuery.data?.atmHost : "",
    unitID: getAtmQuery.data?.unitID ? getAtmQuery.data?.unitID.toString() : "",
    lineTypeID: getAtmQuery.data?.lineTypeID ? getAtmQuery.data?.lineTypeID.toString() : "",
    modemID: getAtmQuery.data?.modemID ? getAtmQuery.data?.modemID.toString() : "",
    atmModelID: getAtmQuery.data?.atmModelID ? getAtmQuery.data?.atmModelID.toString() : "",
    contact: getAtmQuery.data?.contact ? getAtmQuery.data?.contact : "",
    atmTypeID: getAtmQuery.data?.atmTypeID ? getAtmQuery.data?.atmTypeID.toString() : "",
    atmCompany: getAtmQuery.data?.atmCompany ? getAtmQuery.data?.atmCompany.toString() : "",
    isEmporiki: getAtmQuery.data?.isEmporiki ? getAtmQuery.data?.isEmporiki : false,
    isCiti: getAtmQuery.data?.isCiti ? getAtmQuery.data?.isCiti : false,
    description: getAtmQuery.data?.description ? getAtmQuery.data?.description : "",
    lineEndID: getAtmQuery.data?.lineEndID ? getAtmQuery.data?.lineEndID.toString() : "",
    //gpsid: getAtmQuery.data?.gpsid ? getAtmQuery.data?.gpsid.toString() : "",
    //littleBoxSerial: getAtmQuery.data?.littleBoxSerial ? getAtmQuery.data?.littleBoxSerial : "",
    //isdnid: getAtmQuery.data?.isdnid ? getAtmQuery.data?.isdnid.toString() : "",
    //bsimid: getAtmQuery.data?.bsimid ? getAtmQuery.data?.bsimid.toString() : "",
    comments: getAtmQuery.data?.comments ? getAtmQuery.data?.comments : "",
    physicalAddress:  getAtmQuery.data?.physicalAddress ? getAtmQuery.data?.physicalAddress : ""
  }

  const unitType: string | undefined = getAtmQuery.data?.unitType

  const handleSubmit = async (values: IEditAtmForm, { setSubmitting }: FormikHelpers<IEditAtmForm>): Promise<void> => {
    try {
      await editAtmMutation.mutateAsync({
        data: values,
        atmId: atmId
      });
      handleCloseModal();
    }catch(error){
      console.log("values",values)
    } finally {
	    setSubmitting(false);
    }
  }

  if (getAtmQuery.isLoading) {
    return (
      <div className="p-5">
        <LoadingSpinner />
      </div>
    )
  }

  if (getAtmQuery.error) {
    return (
      <div>Υπήρξε κάποιο πρόβλημα στην ανάκτηση του ΑΤΜ.</div>
    )
  }

  return (
    <>
      {!getAtmQuery.isLoading && getAtmQuery.data && !getAtmQuery.error &&
        <EditAtmForm initialValues={initialValues} onSubmit={handleSubmit} unitType={unitType} /> 
      }
    </>
  )
}

interface EditAtmProps {
  atmId: number;
  handleCloseModal: () => void;
}

export default EditAtm;